export class generatereport {
  idReport: number;
  //Id Tercero
  idDebtor: string;
  //Edad cartera desde y hasta
  fromAgePortfolio?: number;
  toAgePortfolio?: number;
  //Estado
  statePortfolio?: number[];
  //Envio
  fileName: string;
  //Fechas de cargue Desde y hasta
  fromUploadFile: Date;
  toUploadFile: Date;
  //Monto desde y hasta
  fromPortfolioBalance?: number;
  toPortfolioBalance?: number;
  //Clave numberermediario
  idAgentKey?: number;
  //RAmo
  idbranch?: number;
  //Sucursal
  idOffice?: number;
  //Poliza
  idPolicy?: number;
  //Asistente-  user name
  AssistantUser: string;
  //Regional/Sucursdal/compendio
  isLocal?: Boolean;
  //Parametros para filtrar por Rol
  idUser: number;

  idUserRole: number;

  idUserOffice: number;

  idUserAgentkey: number;
}
